import * as React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import Accordion from '../../Accordion';
import {
	Wrapper,
	InnerWrapper,
	StatusLabel,
	EmailWrapper,
	Email,
	ButtonRemove,
	ButtonIntegrate,
} from './styles';
import { PopupBody } from '../styles';
import Popup from '../../Popup';
import EmailIntegrationPopup from './EmailIntegrationPopup';
import { getProfileData, saveProfileData } from '../../../containers/ProfilePage/actions';
import { ProfilePageFields } from '../../../containers/ProfilePage/reducer';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import ApiUtils from '../../../utils/api';

interface EmailIntegrationProps {
	clientId: number;
	userEmail: string;
	emailProvider: Api.EmailProviderData;
	dispatch: Dispatch<StoreState>;
}

const EmailIntegration = ({
	clientId,
	userEmail,
	emailProvider: { integrationUrl, email, enabled },
	dispatch,
}: EmailIntegrationProps) => {
	const [isIntegrationPopupDisplayed, setIsIntegrationPopupDisplayed] = React.useState(false);
	const [isRemovePopupDisplayed, setIsRemovePopupDisplayed] = React.useState(false);

	const openIntegrationUrl = (email: string): void => {
		const url = `${integrationUrl}${encodeURIComponent(email)}&wpToken=${ApiUtils.token}`;
		window.open(url, '_blank');
	};

	const handleIntegrationPopupConfirm = (email: string) => {
		setIsIntegrationPopupDisplayed(false);
		openIntegrationUrl(email);
	};

	const handleRemovePopupConfirm = () => {
		setIsRemovePopupDisplayed(false);
		dispatch(saveProfileData({
			emailProvider: { enabled: false },
		} as ProfilePageFields));
	};

	React.useEffect(() => {
		const handleVisibilityChange = () => {
			if (!document.hidden) {
				dispatch(getProfileData(clientId, false));
			}
		};

		document.addEventListener('visibilitychange', handleVisibilityChange);

		return () => {
			document.removeEventListener('visibilitychange', handleVisibilityChange);
		};
	}, []);

	return (
		<Accordion
			title="messages.email_integration"
			isOpened={true}
		>
			<Wrapper>
				{enabled &&
					<StatusLabel>
						{Utils.getSvgIcon('iconset_check-3-bold')}
						<Translate value="messages.enabled" />
					</StatusLabel>
				}
				<InnerWrapper>
					{enabled &&
						<EmailWrapper>
							<Email>
								{email}
							</Email>
							<ButtonRemove
								type="button"
								onClick={() => setIsRemovePopupDisplayed(true)}
							>
								{Utils.getSvgIcon('iconset_close-2')}
							</ButtonRemove>
						</EmailWrapper>
					}
					<ButtonIntegrate
						type="button"
						onClick={() => setIsIntegrationPopupDisplayed(true)}
					>
						<Translate value="messages.integrate" />
					</ButtonIntegrate>
				</InnerWrapper>
			</Wrapper>
			<EmailIntegrationPopup
				isDisplayed={isIntegrationPopupDisplayed}
				onCancel={() => setIsIntegrationPopupDisplayed(false)}
				onConfirm={handleIntegrationPopupConfirm}
				email={email || userEmail}
			/>
			<Popup
				isDisplayed={isRemovePopupDisplayed}
				onCancel={() => setIsRemovePopupDisplayed(false)}
				onConfirm={handleRemovePopupConfirm}
				label={I18n.t('messages.confirmation')}
			>
				<PopupBody>
					<Translate value="messages.remove_email_integration" />
				</PopupBody>
			</Popup>
		</Accordion>
	);
};

export default EmailIntegration;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProfilePage/EmailIntegration/index.tsx